module.exports = __webpack_public_path__ + "static/media/fresh.bb7becbd.jpg";